module.exports = __webpack_public_path__ + "static/Apercu-MediumItalic-9b058f582166b3c178af5ff81ad4797e.ttf";